module.exports = __webpack_public_path__ + "img/blockdit-2.394b0933.svg";